import { Component } from '@angular/core';

import { HasId } from '../../../shared/basic-data-management/has-id.interface';

import { EntityCheckboxListComponent } from '../../../shared/checkbox-list/components/entity-checkbox-list.component';

class ER implements HasId {
	id!: number;
	label!: string;
}

@Component({
	selector: 'emetteur-checkbox-list',
	templateUrl: '../../../shared/checkbox-list/components/entity-checkbox-list.html',
	styleUrls: ['../../../shared/checkbox-list/components/entity-checkbox-list.css']
})
export class EmetteurCheckboxListComponent extends EntityCheckboxListComponent<ER> {
	// Label du champ
	override label = "Emetteur/Récepteur"
	
	// Label de l'option neutre
	override wildcardOptionLabel = "Tous"
	
	// Fonction determinant le label d'une entite
	override getEntityLabel = (value: ER) => value.label;
	
	// Fonction determinant quelle(s) entites(s) doivent etre preselectionnees par defaut
	override shouldBeSelectedByDefaut = (_value: ER) => true; 
	
	// Entites (NB: dans le cas present, l'id sert aussi de valeur finale
	override entities: ER[] = [
		{
			id: 1,
			label: 'Emetteur'
		},
		{
			id: 0,
			label: 'Récepteur'
		}
	];

	constructor( //
	) {
		super();
	}
}